import request from "@/global/request/request";
import API from "@/global/request/api";

export default {
  getQuestionTask(params) {
    return request.get(API.codingQuestionTask, params);
  },
  getMyQuestion(params) {
    return request.get(API.myQuestion, params);
  },
  getExamTags(params) {
    return request.get(API.examTags, params);
  },
  kcellSkills(params = {}) {
    return request.get(API.kcellSkills, params);
  },
  getTaskInfo(id) {
    return request.get(API.taskInfo(id));
  },
  programCreate(params) {
    return request.post(API.programQuestion, params);
  },
  questionCase(params) {
    return request.post(API.questionCase, params);
  },
  programDetail(id) {
    return request.get(API.programInfo(id));
  },
  updateProgram(id, params) {
    return request.put(API.programInfo(id), params);
  },
  getLanguageList() {
    return request.get(API.codingImageList);
  },
  getQuestionExamTags(params) {
    return request.get(API.questionExamTags, params);
  }
};
